module.exports = __webpack_public_path__ + "static/img/langfangwei1.78e5fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/langfangwei1.png
// module id = 5XPj
// module chunks = 1